.uui-expansion-body-wrapper {
  transition: var(--uui-panel-body-transition);
  height: var(--uui-panel-body-height);
  overflow: var(--uui-panel-body-overflow);
}

.uui-expansion-body-content {
  box-sizing: border-box;
  padding-top: var(--uui-panel-body-padding-top);
  transition: var(--uui-panel-body-transition);
}
